<template>
  <div>
    <Breadcrumbs main="Inventario" title="Despachos"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="pull-left">
                <b-button class="mr-2" variant="warning" size="sm" v-on:click="displayModalStock">
                  <feather type="box" style="height: 12px; width: 12px"></feather> Descargar Entregas
                </b-button>
              </div>
              <div class="pull-right">
                <b-button class="mr-2" variant="primary" size="sm" v-on:click="reloadTable">
                  <i class="fa fa-refresh"></i> Actualizar
                </b-button>
                <b-button variant="success" size="sm" :to="{name: 'InventoryDispatchForm'}">
                  <i class="fa fa-map-marker"></i> Agregar despacho
                </b-button>
              </div>
            </div>
            <div class="card-body">
              <form class="form-inline d-flex mx-1 justify-content-end"
                    @submit.stop.prevent="">
                <div class="input-group">
                  <input type="search" placeholder="Buscar" class="form-control"
                         v-model="datatableConfig.quickSearch" v-on:change="doSearch">
                  <div class="input-group-append">
                    <button type="submit" class="btn btn-outline-secondary">
                      <i class="mdi mdi-magnify" /> Buscar
                    </button>
                  </div>
                </div>
              </form>
              <div class="datatable-vue">
                <vdtnet-table
                        ref="table"
                        :fields="datatableConfig.fields"
                        :opts="datatableConfig.options"
                        :hideFooter="false"
                        @displayModalDeleteDispatch="displayModalDeleteDispatch"
                        @displayModalUploadVoucherDispatch="displayModalUploadVoucherDispatch"
                        @displayVoucherDispatch="displayVoucherDispatch"
                        @backDispatchToInventory="backDispatchToInventory"
                        @syncDispatch="syncDispatch"
                        @syncDispatchForm="syncDispatchForm"
                        @displayModalEditDispatch="displayModalEditDispatch">
                </vdtnet-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-status" centered title="Editar estado" ok-title="Cambiar Estado" cancel-title="Cerrar" @ok="updateStatusDispatch" class="theme-modal">
      <div class="" v-if="dispatchEdit">
        <p class="text-center">
          Estás a punto de modificar el estádo del despacho <b>{{this.dispatchEdit.code}}</b>.
        </p>
        <p class="text-center">
          Estado actual:
          <span class="badge badge-warning" v-if="dispatchEdit.status === '0'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-alert" v-else-if="dispatchEdit.status === '300'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-success" v-else-if="['1', '290', '300', '310'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-primary" v-else-if="['4', '280', '220'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-alert" v-else-if="['50', '60', '250'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-warning" v-else-if="dispatchEdit.status === '0'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-danger" v-else-if="syncStatusDispatch.includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
        </p>
        <div class="col-md-12 mb-3">
          <label>Nuevo estado (requerido)</label>
          <multiselect placeholder="Selecciona un nuevo estado" id="type_id"
                       label="name" track-by="id"
                       deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                       v-model="formDispatchEdit.status.value" :options="formDispatchEdit.status.options"
                       :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
            <template slot="noResult">No se encontraron elementos, por favor, cambie el 1filtro de búsqueda.</template>
          </multiselect>
          <b-form-invalid-feedback :state="formDispatchEdit.status.is_valid">{{formDispatchEdit.status.message_error}}</b-form-invalid-feedback>
        </div>
        <div class="col-md-12 mb-3">
          <label>Razón del cambio (requerido)</label>
          <b-form-textarea rows="3"
                           v-model="formDispatchEdit.observation.value"></b-form-textarea>
          <b-form-invalid-feedback :state="formDispatchEdit.observation.is_valid">{{formDispatchEdit.observation.message_error}}</b-form-invalid-feedback>
        </div>
      </div>
    </b-modal>
    <b-modal id="delete-dispatch" centered title="Anular despacho" ok-title="Anular Despacho" cancel-title="Cerrar" @ok="removeObject" class="theme-modal">
      <div class="" v-if="dispatchEdit">
        <p class="text-center">
          Estás a punto de anular el despacho <b>{{this.dispatchEdit.code}}</b>.
        </p>
        <p class="text-center">
          Estado actual:
          <span class="badge badge-warning" v-if="dispatchEdit.status === '0'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-alert" v-else-if="dispatchEdit.status === '300'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-success" v-else-if="['1', '290', '300', '310'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-primary" v-else-if="['4', '280', '220'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-alert" v-else-if="['50', '60', '250'].includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-warning" v-else-if="dispatchEdit.status === '0'">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
          <span class="badge badge-danger" v-else-if="syncStatusDispatch.includes(dispatchEdit.status)">{{statusDispatch.find(item => item['id'] === dispatchEdit.status).name}}</span>
        </p>
        <div class="col-md-12 mb-3">
          <label>Razón de la anulación (requerido)</label>
          <b-form-textarea rows="3"
                           v-model="formDispatchDelete.observation.value"></b-form-textarea>
          <b-form-invalid-feedback :state="formDispatchDelete.observation.is_valid">{{formDispatchDelete.observation.message_error}}</b-form-invalid-feedback>
        </div>
      </div>

    </b-modal>
    <b-modal id="upload-voucher" centered title="Cargar comprobante" ok-title="Cargar" cancel-title="Cerrar" @ok="uploadVoucher" class="theme-modal">
      <div class="" v-if="dispatchEdit">
        <p class="text-center">
          Estás a punto de subir el comprobante del despacho <b>{{this.dispatchEdit.code}}</b>.
        </p>
        <div class="form-row">
          <div class="col-md-12 mb-3">
            <label>Imagen del comprobante (requerido)</label>
            <vue-dropify
                    message="Arrastra una imagen o haz click aquí."
                    uploadIcon="fa fa-upload"
                    removeIcon='fa fa-trash'
                    unit="mb"
                    ref="uploadImage"
                    accept=""
                    @upload="uploadImage"
            ></vue-dropify>
            <b-form-invalid-feedback :state="formDispatchVoucherUpload.image.is_valid">{{formDispatchVoucherUpload.image.message_error}}</b-form-invalid-feedback>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="download-dispatch" centered title="Descargar Despachos" ok-title="Descargar" cancel-title="Cerrar" @ok="downloadDispatchControl" class="theme-modal">
      <div class="col-md-12 mb-3">
        <label for="client_id">Cliente (requerido)</label>
        <multiselect placeholder="Selecciona un cliente" id="client_id"
                     label="business_name" track-by="id"
                     deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                     v-model="formDispatch.client.value" :options="formDispatch.client.options"
                     :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
          <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
          <template slot="noOptions">No hay clientes disponibles.</template>
        </multiselect>
        <b-form-invalid-feedback :state="formDispatch.client.is_valid">{{formDispatch.client.message_error}}</b-form-invalid-feedback>
      </div>
      <div class="col-md-12 mb-3">
        <label for="stock_id">Fecha de inicio (opcional)</label>
        <div class="row">
          <div class="col-12">
            <date-picker type="date" v-model="formDispatch.date_ini.value"
                         :editable="false"></date-picker>
          </div>
        </div>
        <b-form-invalid-feedback :state="formDispatch.date_ini.is_valid">{{formDispatch.date_ini.message_error}}</b-form-invalid-feedback>
      </div>
      <div class="col-md-12 mb-3">
        <label for="stock_id">Fecha de fin (opcional)</label>
        <div class="row">
          <div class="col-12">
            <date-picker type="date" v-model="formDispatch.date_end.value"
                         :editable="false"></date-picker>
          </div>
        </div>
        <b-form-invalid-feedback :state="formDispatch.date_end.is_valid">{{formDispatch.date_end.message_error}}</b-form-invalid-feedback>
      </div>
      <div class="offset-5" v-show="formDispatch.isProcessing">
        <span class="rotate dotted"></span>
      </div>
    </b-modal>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import $ from 'jquery';
  window.jQuery = $;
  import VdtnetTable from 'vue-datatables-net';
  import 'datatables.net-bs4';
  import utils from '../../../utils';
  import Multiselect from "vue-multiselect";
  import VueDropify from 'vue-dropify';
  import axios from "axios";
  import DatePicker from "vue2-datepicker";
  import fileDownload from 'js-file-download';
  export default {
    components: {
      'vue-dropify': VueDropify,
      VdtnetTable,
      Multiselect,
      DatePicker
    },
    data(){
      return{
        datatableConfig : {
          options: {
            lengthMenu: [10, 25, 50],
            pageLength: 10,
            lengthChange: false,
            processing: true,
            serverSide: true,
            searchDelay: 500,
            fixedHeader: true,
            responsive: true,
            ajax: {
              url: axios.defaults.baseURL + '/api/inventory/v1.0/dispatch/?format=datatables&client__status=true&client__deleted=false',
              type: "GET",
              headers: {
                Authorization: 'JWT ' + localStorage.getItem('token')
              },
              dataSrc: (json) => {
                return json['data'];
              }
            },
            language: {
              decimal: "",
              emptyTable: "No hay información",
              info: "Mostrando _START_ a _END_ de _TOTAL_ Entradas",
              infoEmpty: "Mostrando 0 to 0 of 0 Entradas",
              infoFiltered: "(Filtrado de _MAX_ total entradas)",
              infoPostFix: "",
              thousands: ",",
              lengthMenu: "Mostrar _MENU_ Entradas",
              loadingRecords: "Cargando...",
              processing: "Procesando...",
              search: "Buscar:",
              zeroRecords: "Sin resultados encontrados",
              paginate: {
                first: "Primero",
                last: "Ultimo",
                next: "Siguiente",
                previous: "Anterior"
              }
            },
            "drawCallback": function () {
              // const num_row = $('.dataTables_length');
              $('div.vdtnet-container').removeClass('table-responsive');
              // num_row.find('select').removeClass('custom-select form-control');
              $('.dataTables_paginate').addClass('pull-right mt-2');
              $('.dataTables_info').addClass('mt-2');
              // GENERAMOS LA TABLA
              const table = $(this);
              // OBTENEMOS EL TBODY
              const tbody = table.find('tbody');
              // OBTENEMOS EL TFOOT
              const tfoot = table.find('tfoot');
              // SI ES QUE NO HAY LO AGREMAOS
              if(tfoot.length === 0){
                // OBTENGOEL TOTAL DE COLUMNAS
                const totalTH = table.find('thead th').length;
                // INSERTAMOS EL TFOOT
                tbody.after('<tfoot>\n' +
                        '            <tr>\n' +
                        '                <th></th>\n'.repeat(totalTH) +
                        '            </tr>\n' +
                        '        </tfoot>');
              }
            },
            "initComplete": function (){
              // COLUMNAS PARA APLICAR EL SELECT
              const selectFilter = [6];
              const table = this;
              table.api().columns(selectFilter).every( function (){
                const column = this;
                const columnJquery = $(table).find('tfoot th')[column[0][0]];
                const select = $('<select><option value=""></option></select>').appendTo( $(columnJquery).empty())
                        .on( 'change', function () {
                          const val = $.fn.dataTable.util.escapeRegex(
                                  $(this).val()
                          );
                          column
                                  .search( val ? val : '', false, false, false )
                                  .draw();
                        });
                // FILTRAMOS POR POSICIÓN DE LA COLUMNA ESTADO
                if(column[0][0] === 6){
                  // RECORREMOS TODOS LOS ESTADOS Y LOS AGREGAMOS AL SELECT
                  for (let i = 0; i < utils.statusDispatch.length; i++ ){
                    select.append( '<option value="' + utils.statusDispatch[i]['id'] + '">' + utils.statusDispatch[i]['name'] +'</option>' );
                  }
                }
              });
            },
          },
          fields: {
            code: {
              name: 'code',
              label: 'Código',
              data: 'code',
              sortable: true,
            },
            tracking_code: {
              name: 'tracking_code',
              label: 'Código de tracking',
              data: 'tracking_code',
              sortable: true,
            },
            client: {
              name: 'client__business_name',
              label: 'Cliente',
              data: 'client.business_name'
            },
            date_register: {
              name: 'date_register',
              label: 'Fecha de registro',
              data: 'date_register'
            },
            dispatch_client: {
              name: 'name',
              label: 'Cliente a despacho',
              data: 'name'
            },
            address: {
              name: 'address',
              label: 'Dirección',
              data: 'address'
            },
            status: {
              name: 'status',
              label: 'Estado',
              data: 'status',
              render: function (data, type, row) {
                let status;
                const name = utils.statusDispatch.find(options => options['id'] === row['status'])['name'];
                // ANULADO
                if (row['status'] === '0'){
                  status = `<span class="badge badge-warning">${name}</span>`;
                }// EN SINCRONIZACIÓN
                else if (row['status'] === '300'){
                  status = `<span class="badge badge-alert">${name}</span>`;
                }
                // PENDIENTE RUTA ASIGNADA, EM DESPACHO
                else if(['4', '280', '220'].includes(row['status'])){
                  status = `<span class="badge badge-primary">${name}</span>`;
                }// ENTREGADO -- VUELTA AL INVENTARIO - REASIGNADO
                else if (['1', '290', '310'].includes(row['status'])){
                  status = `<span class="badge badge-success">${name}</span>`;
                }
                // DESCONOCIDO, NO HAY QUIEN RECIBA, 1 IDA
                else if(['50', '60', '250'].includes(row['status'])){
                  status = `<span class="badge badge-alert">${name}</span>`;
                }  // DIRECCIÓN INCOMPLETA - NO HAY NÚMERO - CAMBIO DE DOMICILIO - CAMBIO DOMICILIO - REHUSADA - 2 ida
                else if (utils.syncStatusDispatch.includes(row['status'])){
                  status = `<span class="badge badge-danger">${name}</span>`;
                } else {
                  status = row['status'];
                }
                return status;
              }
            },
            actions: {
              label: 'Acciones',
              isLocal: true,
              render: function (data, type, row) {
                let editDispatch = '';
                let deleteDispatch = '';
                let uploadVoucher = '';
                let voucherUrl = '';
                let syncDispatch = '';
                let syncDispatchForm = '';
                // PARA SABER SI PUEDO EDITAR EL ESTADO DEL DESPACHO
                if (row['status'] !== '0') editDispatch = '<a href="javascript:void(0);" data-action="displayModalEditDispatch" title="Cambiar estado"><span class="badge badge-warning"><i class="fa fa-send"></i></span></a> ';
                // if (!['0', '1', '290', '300', '310'].includes(row['status'])){
                //   editDispatch = '<a href="javascript:void(0);" data-action="displayModalEditDispatch" title="Cambiar estado"><span class="badge badge-warning"><i class="fa fa-send"></i></span></a> ';
                // }
                // PARA SABER SI PUEDO ANULAR EL DESPACHO
                if (row['status'] !== '0') deleteDispatch = '<a href="javascript:void(0);" data-action="displayModalDeleteDispatch" title="Anular"><span class="badge badge-danger"><i class="fa fa-trash"></i></span></a> ';
                // if(row['status'] === '4'){
                //   deleteDispatch = '<a href="javascript:void(0);" data-action="displayModalDeleteDispatch" title="Anular"><span class="badge badge-danger"><i class="fa fa-trash"></i></span></a> ';
                // } // PARA SABER SI PUEDO SUBIR EL COMPROBANTE (FINALIZADO, A INVENTARIO, EN SINCRONIZACIÖN, SINCRONIZADO)
                if(['1', '290', '300', '310'].includes(row['status'])){
                  uploadVoucher = '<a href="javascript:void(0);" data-action="displayModalUploadVoucherDispatch" title="Cargar comprobante"><span class="badge badge-success"><i class="fa fa-upload"></i></span></a> ';
                } // DIRECCIÓN INCOMPLETA - NO HAY NÚMERO - CAMBIO DE DOMICILIO - CAMBIO DOMICILIO - REHUSADA - 2 ida
                else if (utils.syncStatusDispatch.includes(row['status'])){
                  // PARA SABER SI VUELVE AL INVENTARIO O REASIGNO A NUEVO DESPACHO
                  syncDispatch =
                          '<a href="javascript:void(0);" data-action="backDispatchToInventory" title="Regresar los productos al inventario"><span class="badge badge-success"><i class="fa fa-backward"></i></span></a> ' +
                          '<a href="javascript:void(0);" data-action="syncDispatch" title="Generar nueva guía"><span class="badge badge-primary"><i class="fa fa-plus"></i></span></a> ';
                }

                // PARA SINCRONIZAR
                if(row['status'] === '300'){
                  syncDispatchForm = '<a href="javascript:void(0);" data-action="syncDispatchForm" title="Sincronizar guía"><span class="badge badge-primary"><i class="fa fa-refresh"></i></span></a> '
                }
                // PARA SABER SI MUENTRO LA IMAGEN
                if(row['voucher'] !== null){
                  const url = `${axios.defaults.baseURL}${row['voucher']}`;
                  voucherUrl = `<a href="${url}" target="_blank" title="Visualizar comprobante"><span class="badge badge-primary"><i class="fa fa-image"></i></span></a> `;
                }
                return `<a href="/tracking/${row['client']['path_tracking']}/${row['id']}" target="_blank" title="Visualizar seguimiento"><span class="badge badge-primary"><i class="fa fa-location-arrow"></i></span></a> ` +
                        editDispatch +
                        syncDispatch +
                        syncDispatchForm +
                        uploadVoucher +
                        '<a href="javascript:void(0);" data-action="displayVoucherDispatch" title="Visualizar guía"><span class="badge badge-danger"><i class="fa fa-file-pdf-o"></i></span></a> ' +
                        voucherUrl +
                        deleteDispatch;
              }
            },
            id: {
              data: 'id',
              visible: false,
              searchable: false,
            },
            voucher: {
              data: 'voucher',
              visible: false,
              searchable: false,
            },
          },
          quickSearch: '',
        },
        statusDispatch: utils.statusDispatch,
        syncStatusDispatch: utils.syncStatusDispatch,
        // DATOS DEL DESPACHO A MODIFICAR
        dispatchEdit: null,
        formDispatchEdit : {
          id: utils.defaultFields(),
          status: utils.defaultFields({
            _type: 'select',
            options: utils.statusDispatchMobile
          }),
          observation: utils.defaultFields()
        },
        formDispatchDelete : {
          id: utils.defaultFields(),
          observation: utils.defaultFields()
        },
        formDispatchVoucherUpload : {
          id: utils.defaultFields(),
          image: utils.defaultFields()
        },
        formDispatch: {
          client: utils.defaultFields({_type: 'select'}),
          date_ini: utils.defaultFields(),
          date_end: utils.defaultFields(),
          isProcessing: false,
        }
      }
    },
    beforeDestroy () {
      clearInterval(this.intervalTable);
    },
    mounted() {
      this.intervalTable = setInterval(() => {
        this.$refs.table.reload();
      }, utils.timeRefresh * 1000);
      this.getClient(this.formDispatch.client);
    },
    methods: {
      uploadImage(event){
        this.$refs.uploadImage.images = [];
        this.formDispatchVoucherUpload.image.value = event[0];
      },
      reloadTable() {
        // ELIMINAOS EL INTERVALO
        clearInterval(this.intervalTable);
        // RECARGAMOS
        this.$refs.table.reload();
        // GENERAMOS EL INTERVALO
        this.intervalTable = setInterval(() => {
          this.$refs.table.reload();
        }, utils.timeRefresh * 1000);
      },
      doSearch() {
        this.$refs.table.search(this.datatableConfig.quickSearch);
      },
      syncDispatch(row){
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de comenzar la <b>sincronización</b> de una guía de despacho <b>${row['code']}</b>. Al sincronizar una guía, ésta cambiará a estado <b>En sincronización</b> para que sea sincronizada. Los productos asociados quedarán libres para que sean asignados nuevamente.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/inventory/v1.0/dispatch_status/' + row['id'] + '/';
            const data = {
              status: '300'
            };
            const response = await utils.updateObject(path, data);
            // SI SE REALIZA EL CAMBIO
            if(response){
              // ESCONDEMOS EL MODAL
              this.$bvModal.hide('delete-dispatch');
              await this.$swal({
                title: 'Completado!',
                type: 'success',
                html: `Se han regresado los productos del despacho al inventario de manera correcta.`,
              });
              this.reloadTable();
            }
          }
        });
      },
      removeObject(bvModalEvt){
        // PARA EVITAR QUE SE ESCONDA EL MODAL
        bvModalEvt.preventDefault();
        let data = {};
        let isValid = utils.generateJsonStructure(this.formDispatchDelete, data);
        if(isValid){
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de <b>anular</b> el despacho <b>${this.dispatchEdit.code}</b>. Al anular un despacho los productos quedarán libres para que sean asignados nuevamente.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              const path = '/api/inventory/v1.0/dispatch_status/' + data['id'] + '/';
              const response = await utils.updateObject(path, data);
              // SI SE REALIZA EL CAMBIO
              if(response){
                // ESCONDEMOS EL MODAL
                this.$bvModal.hide('delete-dispatch');
                await this.$swal({
                  title: 'Anulado',
                  type: 'success',
                  html: `Se ha anulado el despacho de manera correcta.`,
                });
                this.reloadTable();
              }
            }
          });
        }
      },
      displayModalEditDispatch(row) {
        this.formDispatchEdit = {
          id: utils.defaultFields(),
          status: utils.defaultFields({
            _type: 'select',
            options: utils.statusDispatchMobile
          }),
          observation: utils.defaultFields()
        };
        // OBTENGO LA INFORMACIÓN DEL DESPACHO
        this.dispatchEdit = row;
        // GENERO UNA COPIA DE LOS ESTADOS
        let statusAvailable = utils.statusDispatchMobile;
        // ELIMINO EL ESTADO QUE YA SE ENCUENTRA SELECCIONADO
        statusAvailable = statusAvailable.filter(item => item.id !== row['status']);
        //  MODIFICO LAS OPCIONES A SELECCIONAR
        this.formDispatchEdit.status.options = statusAvailable;
        // AGREGAMOS LA ID DEL DESPACHO
        this.formDispatchEdit.id.value = row['id'];
        this.$bvModal.show('edit-status');
      },
      displayModalDeleteDispatch(row) {
        this.formDispatchDelete = {
          id: utils.defaultFields({value: row['id']}),
          status: utils.defaultFields({value: 0}),
          observation: utils.defaultFields()
        };
        // OBTENGO LA INFORMACIÓN DEL DESPACHO
        this.dispatchEdit = row;
        this.$bvModal.show('delete-dispatch');
      },
      async displayModalUploadVoucherDispatch(row) {
        this.dispatchEdit = row;
        await this.$bvModal.show('upload-voucher');
        this.formDispatchVoucherUpload = {
          id: utils.defaultFields({value: row['id']}),
          image: utils.defaultFields()
        };
        // AGREGAMOS LA IMAGEN POR DEFECTO
        if(row['voucher'] !== null) row['voucher'];
      },
      displayVoucherDispatch(row){
        let path;
        path = `${axios.defaults.baseURL}/api/inventory/v1.0/voucher_dispatch/${row['id']}/`;
        window.open(path, '_blank');
      },
      updateStatusDispatch(bvModalEvt){
        // PARA EVITAR QUE SE ESCONDA EL MODAL
        bvModalEvt.preventDefault();
        let data = {};
        let isValid = utils.generateJsonStructure(this.formDispatchEdit, data);
        // OBTENGO EL NOMBRE DEL ESTADO ANTERIOR
        const oldStatusName = utils.statusDispatch.find(item => item['id'] === this.dispatchEdit.status).name;
        if(isValid){
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de <b>cambiar el estado</b> del despacho <b>${this.dispatchEdit.code}</b> de <b>${oldStatusName}</b> a <b>${this.formDispatchEdit.status.value.name}</b>. Se generará un registro al momento de realizar un cambio de estado.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              const path = '/api/inventory/v1.0/dispatch_status/' + data['id'] + '/';
              const response = await utils.updateObject(path, data);
              // SI SE REALIZA EL CAMBIO
              if(response){
                // ESCONDEMOS EL MODAL
                this.$bvModal.hide('edit-status');
                await this.$swal({
                  title: 'Editado',
                  type: 'success',
                  html: `Se ha cambiado el estado del despacho de manera correcta.`,
                });
                // CAMBIAMOS EL ESTADO
                this.reloadTable();
              }
            }
          });
        }
      },
      uploadVoucher(bvModalEvt){
        // PARA EVITAR QUE SE ESCONDA EL MODAL
        bvModalEvt.preventDefault();
        let data = {};
        let isValid = utils.generateJsonStructure(this.formDispatchVoucherUpload, data);
        if(isValid){
          let _formData = new FormData();
          if(!utils.isDict(data.image)){
            delete data.image;
          }
          Object.keys(data).forEach(key => _formData.append(key, data[key]));
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de cargar el comprobante del despacho <b>${this.dispatchEdit.code}</b>. Si ya existe un comprobante cargado al despacho, éste será remplazado.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              const path = '/api/inventory/v1.0/dispatch_voucher/';
              const headers = {'Content-Type': 'multipart/form-data'};
              await axios.post(path, _formData, {headers: headers}).then(async () => {
                this.$bvModal.hide('upload-voucher');
                await this.$swal({
                  title: 'Cargado',
                  type: 'success',
                  html: `Se ha cargado el comprobante  del despacho de manera correcta.`,
                });
                this.reloadTable();
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                console.log(error.response);
                if(error.response.status === 400){
                  utils.generateBackendError(this.formDispatchVoucherUpload, error.response.data);
                  await this.$swal({
                    title: 'Error',
                    type: 'error',
                    html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                  });
                }
              });
            }
          });
        }
      },
      backDispatchToInventory(row){
        this.$swal({
          title: 'Información',
          type: 'info',
          html: `Estás a punto de devolver los productos del despacho <b>${row['code']}</b> al inventario. Al devolver los productos al inventario, éstos quedarán libres para que sean asignados nuevamente.`,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          confirmButtonColor: '#28a745',
          confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
          cancelButtonColor: '#dc3545',
          cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            const path = '/api/inventory/v1.0/dispatch_status/' + row['id'] + '/';
            const data = {
              status: '290'
            };
            const response = await utils.updateObject(path, data);
            // SI SE REALIZA EL CAMBIO
            if(response){
              // ESCONDEMOS EL MODAL
              this.$bvModal.hide('delete-dispatch');
              await this.$swal({
                title: 'Completado!',
                type: 'success',
                html: `Se han regresado los productos del despacho al inventario de manera correcta.`,
              });
              this.reloadTable();
            }
          }
        });
      },
      syncDispatchForm(row){
        this.$router.push({'name': 'InventorySyncDispatchForm', params: { objectId: row['id'] }});
      },
      displayModalStock(){
        this.$bvModal.show('download-dispatch');
      },
      getClient(clientField){
        const path = '/api/core/v1.0/client/';
        const filter = {
          status: true,
          deleted: false
        };
        axios.get(path, {params: filter}).then((response) => {
          if(response.status === 200){
            clientField.options = response.data;
          }
        });
      },
      async downloadDispatchControl(bvModalEvt){
        // PARA EVITAR QUE SE ESCONDA EL MODAL
        await bvModalEvt.preventDefault();
        // SI ES Q AMBOS ESTÁN SELECCIONADOS GENERAMOS LA DESCARGA
        if(this.formDispatch.client.value){
          this.formDispatch.isProcessing = true;
          const path = '/api/inventory/v1.0/dispatch_control/';
          const params = {
            client_id: this.formDispatch.client.value.id,
            date_ini: (this.formDispatch.date_ini.value !== '' && this.formDispatch.date_ini.value !== null) ? this.formDispatch.date_ini.value.toISOString() : null,
            date_end: (this.formDispatch.date_end.value !== '' && this.formDispatch.date_ini.value !== null) ? this.formDispatch.date_end.value.toISOString() : null,
          };
          await axios.get(path, {params: params, responseType: "blob"}).then(async (response) => {
            fileDownload(response.data, `${this.formDispatch.client.value.business_name}-despachos.xlsx`);
            // DEJAMOS LOS VALORES POR DEFECTO
            this.formDispatch.client.value = null
            this.formDispatch.date_ini.value = ''
            this.formDispatch.date_end.value = ''
            this.$bvModal.hide('download-dispatch');
          }).catch(async (error) => {
            // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
            // console.log(error.response);
            if(error.response.status === 400){
              await this.$swal({
                title: 'Error',
                type: 'error',
                html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
              });
            }
          });
          this.formDispatch.isProcessing = false;
        } else {
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
        // this.$swal({
        //   title: 'Error',
        //   type: 'error',
        //   html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
        // });
        //
      },
    },
  }
</script>

<style>
  table img {
    width: 100px;
    height: 100px;
  }
</style>